import { render, staticRenderFns } from "./drawer_salesGoods.vue?vue&type=template&id=046f6efe&scoped=true&"
import script from "./drawer_salesGoods.vue?vue&type=script&lang=js&"
export * from "./drawer_salesGoods.vue?vue&type=script&lang=js&"
import style0 from "./drawer_salesGoods.vue?vue&type=style&index=0&id=046f6efe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046f6efe",
  null
  
)

export default component.exports